import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { validateNumberInput } from "../../../../utils/validateFields";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI303_5 = ({ hide }) => {
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
  const questionData = [
    {
      fieldName: "totalConsumption",
      title: "i. Total water consumption from all areas in kiloliters.",
      type: "number",
      placeholder: "Enter Number",
      letter: "i.",
    },
    {
      fieldName: "totalConsumptionWaterStress",
      title:
        "ii. Total water consumption from all areas with water stress in kiloliters.",
      type: "number",
      placeholder: "Enter Number",
      letter: "ii.",
    },
    {
      fieldName: "changeInWaterStorage",
      title:
        "iii. Change in water storage in kiloliters, if significant water-related impacts have been identified.",
      type: "number",
      placeholder: "Enter Number",
      letter: "iii.",
    },
    {
      fieldName: "contextualInformation",
      title:
        "iv. Provide any contextual information necessary to understand how the data have been compiled, including details about the standards, methodologies, and assumptions used. This includes specifying if the information is calculated, estimated, modelled, or sourced from direct measurements, and the approach taken for this, such as the utilization of any sector-specific factors.",
      type: "text",
      placeholder: "Enter Text",
      letter: "iv.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear : false)
        setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.waterConsumption;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data)
      setFormData({
        totalConsumption: data?.totalConsumption || "",
        totalConsumptionWaterStress: data?.totalConsumptionWaterStress || "",
        changeInWaterStorage: data?.changeInWaterStorage || "",
        contextualInformation: data?.contextualInformation || "",
      });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name !== "contextualInformation" && !validateNumberInput(value)) return;

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let transformedData2 = {
        waterConsumption: formData,
        type: "GRI300",
        submitted303_5: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/304-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/304-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && (
        <p className={styles.section_heading}>303 : Water & Effluents</p>
      )}
      <p className={styles.main_heading}>303-5 : water Consumption </p>
      {questionData?.map((el) => (
        <Box sx={{ width: "99.5%" }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            {/* <p className={styles.ques_heading}>{el?.letter}</p> */}
            <p
              className={styles.ques_heading}
              style={{ marginTop: hide ? "-1rem" : "0" }}
            >
              {el?.title}
            </p>
          </Box>
          <Box sx={{ ml: 2 }}>
            <InputField
              placeholder={el?.placeholder}
              fieldName={el?.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el?.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI303_5;
